/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  HStack,
  useDisclosure,
} from '@chakra-ui/core';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IoArrowBackOutline } from 'react-icons/io5';
import { useHistory } from 'react-router-dom';
import { useUnsavedChanges } from '../hooks/useUnsavedChanges';

export const UnsavedChangesModal = () => {
  const { t } = useTranslation('questionnaireTemplate');
  const history = useHistory() as any;
  const cancelRef = useRef<HTMLButtonElement>(null);
  const [shouldBlock, setShouldBlock] = React.useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { isDirty } = useUnsavedChanges({ isDisabled: shouldBlock });

  // istanbul ignore next
  const handleLeave = () => {
    onClose();
    setShouldBlock(true);
    setTimeout(() => {
      history.goBack();
    }, 0);
  };

  const handleOnOpen = () => {
    if (isDirty) {
      onOpen();
      setShouldBlock(false);
    } else {
      history.goBack();
    }
  };
  return (
    <>
      <Button
        size="sm"
        variant="ghost"
        paddingX={1}
        borderRadius="50%"
        colorScheme="gray"
        onClick={handleOnOpen}
        data-testid="back-button"
      >
        <IoArrowBackOutline fontSize={24} />
      </Button>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered closeOnOverlayClick={false}>
        <AlertDialogOverlay>
          <AlertDialogContent borderRadius="xl">
            <AlertDialogHeader fontSize="lg" fontWeight="bold" pt={6} px={6} data-testid="unsaved-changes-modal-title">
              {t('formBuilder.unsavedChangesModal.title')}
            </AlertDialogHeader>

            <AlertDialogBody px={6} py={4} data-testid="unsaved-changes-modal-body">
              {t('formBuilder.unsavedChangesModal.body')}
            </AlertDialogBody>

            <AlertDialogFooter pb={6} px={6}>
              <HStack spacing={3}>
                <Button
                  colorScheme="red"
                  onClick={handleLeave}
                  data-testid="unsaved-changes-cancel-button"
                  variant="solid"
                  fontWeight="bold"
                  px={6}
                >
                  {t('formBuilder.unsavedChangesModal.exit')}
                </Button>
                <Button
                  ref={cancelRef}
                  colorScheme="blue"
                  onClick={onClose}
                  data-testid="unsaved-changes-continue-editing-button"
                  variant="solid"
                  fontWeight="bold"
                  px={6}
                >
                  {t('formBuilder.unsavedChangesModal.continueEditing')}
                </Button>
              </HStack>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};
